/*
 * cart-line-split.js — TICK-3946 #1 / #2 (David's review of TICK-3928)
 *
 * When a cart line's quantity exceeds the units on hand, split it into two
 * lines for the same variant: the ready-to-ship units stay on the original
 * line, the excess moves to a second line stamped with the hidden
 * `_split: mto` property (so it never merges back and always renders as
 * Made to Order — see cart-line-availability.liquid). Each half gets its
 * own "Availability" property rewritten, which is what checkout and the
 * order show — the add-time property alone went stale the moment the
 * quantity changed in the cart (#2).
 *
 * Driven entirely by the data-* attributes the Liquid renders on
 * [data-cart-line-availability]; re-runs whenever the cart re-renders
 * (theme:cart:change / api-cart-items) and converges: after a split no
 * line carries data-split="true", so nothing more happens.
 */
(function () {
  'use strict';

  var busy = false;
  var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  if (root.slice(-1) !== '/') root += '/';

  function post(path, payload) {
    return window.fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  function pending() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-line-availability][data-split="true"]'))
      .filter(function (el) { return el.getAttribute('data-forced-mto') !== 'true' && !el.hasAttribute('data-split-handled'); });
  }

  function split() {
    if (busy) return;
    var nodes = pending();
    if (!nodes.length) return;
    busy = true;

    var chain = Promise.resolve();
    nodes.forEach(function (el) {
      var key = el.getAttribute('data-line-key');
      var variantId = parseInt(el.getAttribute('data-variant-id'), 10);
      var qty = parseInt(el.getAttribute('data-line-qty'), 10);
      var onHand = parseInt(el.getAttribute('data-on-hand'), 10);
      var label = el.getAttribute('data-property-label') || 'Availability';
      if (!key || !variantId || isNaN(qty) || isNaN(onHand) || onHand < 1 || qty <= onHand) return;

      // Stamp NOW: the pre-rendered DOM stays on screen until the re-render
      // lands, and a second pass over the same node double-counted the Made
      // to Order half (RTS 2 / MTO 2 instead of 2 / 1 — seen on staging).
      el.setAttribute('data-split-handled', '');
      var rtsProps = {}; rtsProps[label] = el.getAttribute('data-rts-property') || '';
      var mtoProps = { _split: 'mto' }; mtoProps[label] = el.getAttribute('data-mto-property') || '';

      // Shopify lists the NEWEST line first, and David wants Made to Order
      // listed BELOW Ready to Ship — so the existing line becomes the MTO
      // half and the ready-to-ship units are added as the new (top) line.
      chain = chain
        .then(function () { return post('cart/change.js', { id: key, quantity: qty - onHand, properties: mtoProps }); })
        .then(function () { return post('cart/add.js', { items: [{ id: variantId, quantity: onHand, properties: rtsProps }] }); });
    });

    chain
      .then(function () {
        // Reload only. Dispatching theme:cart:change here re-entered split()
        // through our own listener while the stale DOM was still up.
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function (err) { if (window.console) console.warn('cart-line-split:', err); })
      .then(function () { busy = false; });
  }

  // Cart page + drawer both re-render the line items via api-cart-items;
  // watch for the flagged block to appear rather than guessing which event
  // fires last. Debounced; attribute-only work so it can't loop on itself.
  // TICK-3953: no debounce — the row is pre-rendered as two lines already,
  // so the sooner the real split lands the sooner the pending row is real.
  var timer = null;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(split, 0);
  }
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) { schedule(); return; }
    }
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('theme:cart:change', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
